module.exports = __webpack_public_path__ + "static/img/animales_21.788bd248.jpg";